import Images from "../../../utility/imagePaths";
import { TechEcoSystemItemTypes } from "../../../utility/types/generaTypes";
import "./EcoSystemCard.css";

type EcoSystemCardProps = {
  ecoSystem: TechEcoSystemItemTypes;
};
const EcoSystemCard = ({ ecoSystem }: EcoSystemCardProps) => {
  const onClickCard = (path: string) => {
    window.open(path, "_blank");
  };
  return (
    <div
      className="ecosystemCard_container"
      onClick={() => onClickCard(ecoSystem.to)}
    >
      <div className="ecosystemCard_header_container">
        <p className="ecosystem_title">{ecoSystem.title}</p>
        <div className="ecosystemCard_header_rightContainer">
          <p>{ecoSystem.type}</p>
        </div>
      </div>
      <div className="ecosystemCard_bottom_container">
        <img src={Images.SVG_STAR_ICON} alt="star" />
        <p className="ecosystem_description">{ecoSystem.description}</p>
      </div>
    </div>
  );
};

export default EcoSystemCard;
